import { ArticleLayout } from '../../components/layout/ArticleLayout';
import { articles } from '../../data/articles';

export default function GlobalArtMarket2023() {
  const article = articles['global-art-market-2023'];
  
  return <ArticleLayout article={article} />;
} 